import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class GetDataService {

    constructor(private http: HttpClient) {
    }

    getAllJobs() {
        return this.http.get('agri/allJobs');
    }
}
